<template>
  <div class="background-wrapper-other">
    <div class="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/">HARUMIFLAG</router-link></li>
          <li><router-link to="/information">インフォメーション一覧</router-link></li>
        </ul>
      </div>
    </div>
    <div class="info-list">
      <div class="info-cont">
        <h2>INFORMATION<span>インフォメーション一覧</span></h2>
        <div class="info-cont__list">
          <div class="container">
            <InformationList />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CONSTANT from "../../../constant";
import { RouterLink } from "vue-router";
import { metaData } from '@/utils/helper';

export default {
  name: "Information",
  components: {
    InformationList: () =>
      import("@/components/common/information/InformationList.vue"),
  },
  data() {
    return {
      // informationList: CONSTANT.dataInformationList,
      // list_information: [],
    };
  },
  created() {
    metaData(
      `インフォメーション | HARUMIFLAGタウンポータル`,
      '中央区晴海・HARUMIFLAGのインフォメーション一覧。お知らせしたい情報を更新しています。',
      'HARUMIFLAGタウンポータル',
      'blog',
    )
  },
};
</script>
